import { groupBy } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { URL } from "../../../../utils/Constants";

function AdmitCardTemplate2(props) {
  const [filteredTable, setFilteredTable] = useState(null);
  const [filtereduniqueDates, setFilteredUniqueDates] = useState(null);
  const [routineData, setRoutineData] = useState(null);

  useEffect(() => {
    if (props.student !== undefined) {
      transformstudentData(props?.student?.subjects);
      setRoutineData(props?.student?.subjects);
    }
  }, [props.student]);

  const transformstudentData = (data) => {
    const uniqueDates = Array.from(
      new Set(
        data.flatMap((d) => [
          d?.assessmentTheoryFromDate &&
            moment(d.assessmentTheoryFromDate).format("YYYY-MM-DD"),
          d?.assessmentPracticalFromDate &&
            moment(d.assessmentPracticalFromDate).format("YYYY-MM-DD"),
        ]),
      ),
    )
      .filter((item) => !!item)
      .sort();

    const groupedByDateTheory = groupBy(data, (entry) =>
      moment(entry.assessmentTheoryFromDate).format("YYYY-MM-DD"),
    );
    const groupedByDatePractical = groupBy(data, (entry) =>
      moment(entry.assessmentPracticalFromDate).format("YYYY-MM-DD"),
    );

    const mappedSubjects = Object.entries(groupedByDateTheory)
      .concat(Object.entries(groupedByDatePractical))
      .map(([date, entries]) => {
        const datePart = date.split(" ")[0];
        return entries.map((entry) => {
          let theoryDate;
          let practicalDate;
          if (entry?.assessmentTheoryFromDate) {
            theoryDate =
              moment(entry?.assessmentTheoryFromDate).format("YYYY-MM-DD") ===
              datePart;
          }
          if (entry?.assessmentPracticalFromDate) {
            practicalDate =
              moment(entry?.assessmentPracticalFromDate).format(
                "YYYY-MM-DD",
              ) === datePart;
          }
          let time = "";
          let subjectType = "";
          if (theoryDate) {
            time = `Th-${moment(entry.assessmentTheoryFromDate).format(
              "hh:mm A",
            )} to ${moment(entry.assessmentTheoryToDate).format("hh:mm A")}`;
            subjectType = "Th";
          }
          if (practicalDate) {
            if (time) {
              time += ` & Pr-${moment(entry.assessmentPracticalFromDate).format(
                "hh:mm A",
              )} to ${moment(entry.assessmentPracticalToDate).format(
                "hh:mm A",
              )}`;
              subjectType = "Th & Pr";
            } else {
              time = `Pr-${moment(entry.assessmentPracticalFromDate).format(
                "hh:mm A",
              )} to ${moment(entry.assessmentPracticalToDate).format(
                "hh:mm A",
              )}`;
              subjectType = "Pr";
            }
          }
          return {
            subject: entry.name,
            date: datePart,
            time: time,
            subjectType: subjectType,
          };
        });
      });

    const newTable = mappedSubjects.flat().reduce((acc, curr) => {
      if (!acc[curr.date]) {
        acc[curr.date] = [];
      }
      if (curr.time !== "") {
        const existingSubject = acc[curr.date].find((subject) =>
          subject.startsWith(curr.subject),
        );
        if (!existingSubject) {
          acc[curr.date].push(`${curr.subject} (${curr.subjectType})`);
        }
      }
      return acc;
    }, {});

    setFilteredTable(newTable);
    setFilteredUniqueDates(uniqueDates);
    return { table: newTable, uniqueDates };
  };

  return (
    <div style={{ padding: "16px" }} className="admitCardContainer">
      <div
        style={{ position: "relative" }}
        className="d-flex align-item-center"
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: 0,
            transform: "translateY(-50%)",
          }}
          className="d-flex justify-content-start align-item-center"
        >
          <div className="d-flex align-items-center justify-content-center">
            {props?.schoolInfos?.imageName && (
              <img
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "20px",
                }}
                src={`${URL.imageSelectURL}${props?.schoolInfos?.imageName}`}
                alt="profile"
              />
            )}
          </div>
        </div>
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <div style={{ width: "110mm" }}>
            <div className="d-flex justify-content-center align-items-center mb-1">
              <b style={{ fontSize: "1.3rem", textAlign: "center" }}>
                {props?.schoolInfos?.name
                  ? `${props?.schoolInfos?.name}`
                  : "---------------"}
                {props?.schoolInfos?.acronym?.trim()
                  ? ` (${props?.schoolInfos?.acronym})`
                  : null}
              </b>
            </div>
            <div
              style={{ fontSize: "16px" }}
              className="d-flex justify-content-center align-items-center mb-1"
            >
              {props?.schoolInfos?.address
                ? `${props?.schoolInfos?.address}`
                : "---------------"}
            </div>
            <div
              className="d-flex justify-content-center align-items-center mb-1"
              style={{ fontSize: "16px" }}
            >
              {!props?.assessmentSubjectValue?.assessmentName
                ? "---------------"
                : `${props.assessmentSubjectValue?.assessmentName}`}
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <p
                className="px-5 p-2"
                style={{
                  border: "1px solid black",
                  borderRadius: "12px",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                Student Admit Card
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="my-4">
        <div>
          <div style={{ fontSize: "1rem" }}>
            {/* p-2 */}
            <div
              className="form-group"
              style={{ marginBottom: "20px !important" }}
            >
              <div>
                <label htmlFor="studentName">
                  {" "}
                  <b>Name : </b>
                  {props?.student?.people?.name}
                </label>
              </div>
            </div>

            <div
              className="form-group"
              style={{ marginBottom: "20px !important" }}
            >
              <div>
                <label htmlFor="classProgramme">
                  <b>Programme, Class : </b>{" "}
                  {props?.classValue?.name
                    ? `${props?.classValue?.name}`
                    : "---------------"}
                  {/* {props?.className ? `, ${props?.className}` : null} */}
                  {props?.student
                    ? `, ${props?.student?.yearLevel?.name}`
                    : null}{" "}
                  {props?.student?.classRoom?.name
                    ? `, ${props?.student?.classRoom?.name}`
                    : null}
                </label>
              </div>{" "}
            </div>

            <div
              className="form-group"
              style={{ marginBottom: "20px !important" }}
            >
              <div>
                <label htmlFor="validityDate">
                  <b>Symbol No : </b>
                  {props?.student?.symbolNo ? props?.student?.symbolNo : ""}
                </label>
              </div>{" "}
            </div>

            <div
              className="form-group d-flex align-items-center"
              style={{ marginBottom: "20px !important" }}
            >
              <div>
                <label htmlFor="digitalSignature">
                  <b>Roll No : </b>
                </label>
              </div>
              <div style={{ marginLeft: "55mm" }}>
                <label htmlFor="digitalSignature">
                  <b>Hall No : </b>
                </label>
              </div>{" "}
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-between align-item-center">
        <div
          style={{ fontSize: "16px" }}
          className="d-flex justify-content-start align-item-center"
        >
          Note :{props?.note ? ` ${props?.note}` : " ____________"}
        </div>

        <div
          style={{ fontSize: "16px" }}
          className="d-flex justify-content-end align-item-center"
        >
          Principal : ____________
        </div>
      </div>
    </div>
  );
}

export default AdmitCardTemplate2;
